export const routerPath = {
  index: "/",
  login: "/login/",
  listKyc: "/kycApplications",
  newKyc: "/new-kyc/",
  kycApplication: "/kycApplications/:applicationId",
  kycApplicationsSettings: "/kycApplications/settings",
  modifyKyc: "/modifyKyc/:kycId",
  successApprove: "/success/",
  callback: "/callback.html",
  silentRenew: "/silent_redirect.html",
  kyc: "/new-kyc/",
  newKycSme: {
    basePath: "/new-kyc",
    step1: "/new-kyc/1",
    step2: "/new-kyc/2",
    step3: "/new-kyc/3",
    step4: "/new-kyc/4",
    step5: "/new-kyc/5",
    step6: "/new-kyc/6",
    step7: "/new-kyc/7",
    step8: "/new-kyc/8"
  },
  waitingRoom: "/waitingRoom/:id"
};

export const linkPath = {
  index: { url: "/" },
  login: { url: "/login/" },
  listKyc: { url: "/kycApplications/" },
  newKyc: { url: "/newKyc/" },
  kyc: { url: "/newKycSME/" },
  modifyKyc: { url: "/modifyKyc/" },
  successApprove: { url: "/success/" },
  callback: { url: "/callback.html" },
  silentRenew: { url: "/silent_redirect.html" },
  waitingRoom: { url: "/waitingRoom/:id" }
};
